import $ from 'jquery';

export const bindPwdToggle = $wrapper => {
    const $input = $wrapper.find('input');
    const $eye = $wrapper.find('i');

    $eye.on('click', () => {
        if ($eye.hasClass('fa-eye')) {
            $input.attr('type', 'text');
        } else {
            $input.attr('type', 'password');
        }
        $eye.toggleClass('fa-eye fa-eye-slash');
    });
};